// src/help/page/types.ts
var HelpPageAriResourceOwner = "help", HelpPageAriResourceType = "page";

export {
  HelpPageAriResourceOwner,
  HelpPageAriResourceType
};
